import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AdminScansRouter } from "../modules/scans/scans.router";
import { DashboardLayout } from "../layouts/dashboard.layout";
import { ProtectedRoute } from "./protected-route";
import { Dashboard } from "../modules/dashboard";
import { NotFound } from "../modules/404";
import { AdminSitesRouter } from "../modules/sites/sites.router";
import { AdminProductsRouter } from "../modules/products/products.router";
import { UsersRouter } from "../modules/users/users.router";
import { CategoriesRouter } from "../modules/categories/categories.router";
import { Sites } from "../modules/sites/pages";
import { SentinelsRouter } from "../modules/sentinels/sentinels.router";
import { AdminRoundsRouter } from "../modules/rounds/rounds.router";
import { AdminReferencesRouter } from "../modules/references/references.router";
import { CompareRouter } from "../modules/compare/compare.router";
import { FavoritesRouter } from "../modules/favorites/favorites.router";

export const AdminRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route element={<ProtectedRoute roles={["Any"]} />}>
            <Route path="/" element={<Dashboard />} />
          </Route>
          {AdminScansRouter}
          {AdminSitesRouter}
          {AdminProductsRouter}
          {AdminReferencesRouter}
          {UsersRouter}
          {CategoriesRouter}
          {SentinelsRouter}
          {AdminRoundsRouter}
          {CompareRouter}
          {FavoritesRouter}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
